import { useQuery } from "react-query";
import { getAssociatedHierarchyById } from "actions/CarrierAgreementMgmt/Hierarchy";

export const useGetAssociatedHierarchyById = (hierarchyId) => {
  return useQuery(
    ["GetAssociatedHierarchyById", hierarchyId],
    () => getAssociatedHierarchyById(hierarchyId),
    {
      refetchOnWindowFocus: false,
    }
  );
};
